import { format, isValid, parse, parseISO } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
import { formatInTimeZoneBr } from '~/utils/formatToTimeZone';

export function formatDate(data: string): string | null {
  if (!data) {
    return null;
  }

  // Verificar se a string tem o comprimento correto
  if (data?.length !== 8 && data?.length !== 10) {
    return null;
  }

  let dia;
  let mes;
  let ano;
  // Extrair dia, mês e ano da string
  if (data.indexOf('/') !== -1) {
    const dataArr = data.split('/');
    dia = parseInt(dataArr[0], 10);
    mes = parseInt(dataArr[1], 10);
    ano = parseInt(dataArr[2], 10);
  } else {
    dia = parseInt(data.substring(0, 2), 10);
    mes = parseInt(data.substring(2, 4), 10);
    ano = parseInt(data.substring(4), 10);
  }

  // Verificar se o dia, mês e ano são válidos
  if (Number.isNaN(dia) || Number.isNaN(mes) || Number.isNaN(ano)) {
    return null;
  }

  // Verificar se o dia e mês são válidos dentro do calendário
  if (dia < 1 || dia > 31 || mes < 1 || mes > 12) {
    return null;
  }

  // Verificar se fevereiro não tem mais de 29 dias (considerando que este é um ano bissexto)
  if (mes === 2 && dia > 29) {
    return null;
  }

  // Verificar se abril, junho, setembro ou novembro não têm mais de 30 dias
  if ([4, 6, 9, 11].includes(mes) && dia > 30) {
    return null;
  }

  // Retornar a data formatada
  return `${dia}/${mes}/${ano}`;
}

export function parseDate(str: string, _format: string) {
  let parsed = parse(str, _format, new Date());
  if (isValid(parsed)) {
    return parsed;
  }
  parsed = new Date(str.replace(/(\d{2})(\d{2})(\d{4})/, '$1/$2/$3'));
  return isValid(parsed) ? parsed : undefined;
}

export function formattedDate(dateString: string): string {
  const formatted = format(new Date(dateString), 'dd/MM/yyyy');
  return formatted;
}

export function isDateInPast(date?: string): boolean {
  if (!date) {
    return false;
  }
  const today = new Date();
  const dateToCheck = utcToZonedTime(parseISO(date), 'UTC');
  return today > dateToCheck;
}

export function formataDiaMesAno(date: string): string {
  return formatInTimeZoneBr(`${date}T00:00:00Z`, 'dd/MM/yyyy');
}

export function formataMesStrAno(date: string): string {
  let newDate = date;
  if (date.includes('/')) {
    newDate = date.split('/').reverse().join('-');
  }
  if (newDate.includes('Z')) {
    const d = newDate.split('T')[0];
    newDate = d;
  }
  return formatInTimeZoneBr(`${newDate}T00:00:00Z`, 'MMM/yyyy');
}
